import { render, staticRenderFns } from "./search-item.vue?vue&type=template&id=18e7f17a&scoped=true"
import script from "./search-item.vue?vue&type=script&lang=js"
export * from "./search-item.vue?vue&type=script&lang=js"
import style0 from "./search-item.vue?vue&type=style&index=0&id=18e7f17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e7f17a",
  null
  
)

export default component.exports